import { Toast } from 'vant'

import CryptoJs from 'crypto-js'
export function responseCodeMsg(res) {
  if (res.code === 1) {
    Toast({
      message: res.msg || '登录信息过期',
      type: 'fail',
      duration: 5 * 1090,
    })
    // console.log(location);
    let nextPath = location.hash.toString().split('#')[1]
    // console.log(nextPath);
    location.href =
      process.env.NODE_ENV == 'production'
        ? location.origin + location.pathname + '#/login?nextPath=' + nextPath
        : location.origin + location.pathname + '#/login?nextPath=' + nextPath
  } else if (res.code === 3) {
    Toast({
      message: res.msg || '请求异常',
      type: 'fail',
      duration: 3 * 1000,
      customClass: 'ark toast message',
    })
  }
}

//在这个方法中，array 参数是要被分割的对象数组，chunkSize 参数是每个分割数组的数量。该方法会将原始数组逐个按照指定的 chunkSize 进行切割，并将切割后的数组存储在 result 数组中，最后将 result 数组返回。
export function splitArrayIntoChunks(array, chunkSize) {
  const result = []
  for (var i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize))
  }
  return result
}
// 解密
export function decryptCryptoJs(text, key) {
  const decrypt = CryptoJs.AES.decrypt(text, CryptoJs.enc.Utf8.parse(key), {
    mode: CryptoJs.mode.ECB,
    padding: CryptoJs.pad.Pkcs7,
  })
  return CryptoJs.enc.Utf8.stringify(decrypt)
}

// 加密
export function encryptCryptoJs(word) {
  const key = CryptoJS.enc.Utf8.parse('front_sercet')
  const srcs = CryptoJS.enc.Utf8.parse(word)
  const encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
  return encrypted.toString()
}

// 文件下载ppt,xls,word
export function dowloadByUrl(str, fileName) {
  console.log(str, fileName, 'dowloadByUrl---1')
  //   let that = this
  getBlob(str, function (blob) {
    saveAs(blob, fileName)
  })
  function getBlob(url, cb) {
    console.log(url, cb, '调用getBlob')
    var xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'
    xhr.onload = function () {
      if (xhr.status === 200) {
        cb(xhr.response)
      }
    }
    xhr.send()
  }
  function saveAs(blob, filename) {
    console.log(blob, filename, '调用saveAs')
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename)
    } else {
      var link = document.createElement('a')
      var body = document.querySelector('body')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.style.display = 'none'
      body.appendChild(link)
      link.click()
      body.removeChild(link)
      window.URL.revokeObjectURL(link.href)
    }
  }
}

// 获取url上的参数
export const GetRequestParameters = (locationsearch) => {
  let url = location.search
  let theRequest = new Object()
  if (url.indexOf('?') != -1) {
    let str = url.substr(1)
    let strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1]
    }
  }
  return theRequest
}

export const getQueryString1 = (url) => {
  var theRequest = new Object()
  if (url.indexOf('?') != -1) {
    var str = url.substr(1)
    let strs = str.split('&')
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return theRequest
}

export const getQueryString = (url) => {
  let paramsArr = []
  if (url.indexOf('?') != -1) {
    let strs = url.split('?')
    let pArr = strs[1].split('&')
    debugger
    pArr.forEach((item) => {
      let keyVal = item.split('=')
      let obj = {
        tenantCode: item.sub(item, ''),
      }
      paramsArr.push(obj)
    })
  }
}

export const GetQueryString2 = (url) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg) //获取url中"?"符后的字符串并正则匹配
  var context = ''
  if (r != null) context = decodeURIComponent(r[2])
  reg = null
  r = null
  return context == null || context == '' || context == 'undefined' ? '' : context
}

// 将GCJ-02(火星坐标)转为百度坐标(DB-09):
export function gcj02toBaidu(latitude, longitude) {
  var pi = (3.14159265358979324 * 3000.0) / 180.0

  var z = Math.sqrt(longitude * longitude + latitude * latitude) + 0.00002 * Math.sin(latitude * pi)
  var theta = Math.atan2(latitude, longitude) + 0.000003 * Math.cos(longitude * pi)
  var a_latitude = z * Math.sin(theta) + 0.006
  var a_longitude = z * Math.cos(theta) + 0.0065

  return { latitude: a_latitude, longitude: a_longitude }
}

export const openMap = (longitude, latitude, name, mapApp) => {
  // console.log(mapApp, '11111111111111111111111')
  let baiduObj = gcj02toBaidu(latitude, longitude)
  let url
  if (mapApp === '高德地图') {
    url = `https://uri.amap.com/marker?position=${longitude},${latitude}&name=${encodeURIComponent(
      name
    )}&src=mypage&coordinate=gaode&callnative=1`
  } else if (mapApp === '腾讯地图') {
    // url = `qqmap://map/marker?marker=coord:${latitude},${longitude};title:${encodeURIComponent(
    //   name
    // )};addr:${encodeURIComponent(name)}`
    url = `qqmap://map/rgeo?location=${latitude},${longitude}&name=${encodeURIComponent(name)}&coord_type=1&policy=0`
  } else if (mapApp === '百度地图') {
    url = `baidumap://map/marker?location=${baiduObj.latitude},${baiduObj.longitude}&title=${encodeURIComponent(
      name
    )}&content=${encodeURIComponent(name)}&src=webapp`
  }

  // 使用iframe打开URL Scheme，避免直接跳转导致页面卡死
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = url
  document.body.appendChild(iframe)
  setTimeout(() => {
    document.body.removeChild(iframe)
  }, 1000)

  // 定时器检测是否唤起成功，如果失败则跳转到网页版地图
  let timer = setTimeout(() => {
    if (mapApp === '高德地图') {
      window.location.href = `https://uri.amap.com/marker?position=${longitude},${latitude}&name=${encodeURIComponent(
        name
      )}&src=mypage&coordinate=gaode&callnative=1` // 默认跳转高德网页版
    } else if (mapApp === '百度地图') {
      const uri = `marker?location=${baiduObj.latitude},${baiduObj.longitude}&title=${encodeURIComponent(
        name
      )}&content=${encodeURIComponent(name)}`
      window.location.href = `https://api.map.baidu.com/${uri}&output=html&src=webapp.baidu.openAPIdemo`
    } else if (mapApp === '腾讯地图') {
      window.location.href = `https://apis.map.qq.com/uri/v1/marker?marker=coord:${latitude},${longitude};title:${encodeURIComponent(
        name
      )};addr:${encodeURIComponent(name)}`
    }
  }, 2000)

  window.addEventListener('blur', () => {
    clearTimeout(timer)
  })
}
